import LiquidGlassButton from "../../components/LiquidGlassButton";
import { Ic, icons } from "../../components/Icons";
import { APP_STORE_URL } from "../../config/storeLinks";

export default function StudioDeviceRevealSection() {
  return (
    <section
      id="studio"
      className="section studio-device-reveal-section"
      aria-labelledby="studio-device-reveal-title"
    >
      <div className="studio-device-reveal-inner">
        <div className="studio-device-reveal-copy reveal reveal-d1">
          <div className="studio-device-reveal-copy-eyebrow">
            <Ic d={icons.ateno} size={14} />
            Ateno Studio
          </div>
          <h2 id="studio-device-reveal-title" className="studio-device-reveal-title">
            <span>Interior design</span>
            <span>for everyone.</span>
          </h2>
          <p className="studio-device-reveal-subhead">
            Ateno Studio is the mobile app for redesigning real rooms, exploring styles, and turning everyday spaces into clear interior concepts.
          </p>
          <div className="studio-device-reveal-actions">
            <LiquidGlassButton
              href={APP_STORE_URL}
              width={136}
              height={50}
              tone="dark"
              fallbackClassName="btn btn-white btn-lg btn-hero-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store
            </LiquidGlassButton>
          </div>
        </div>

        <div className="studio-device-reveal-visual reveal reveal-d2" aria-label="Ateno Studio app preview">
          <div className="studio-device-reveal-room-panel" aria-hidden="true">
            <img src="/assets/beta/beta-second-photo.png" alt="" loading="lazy" decoding="async" />
          </div>

          <div className="studio-device-reveal-phone" aria-hidden="true">
            <div className="studio-device-reveal-phone-screen">
              <img src="/assets/beta/beta-second-photo.png" alt="" className="studio-device-reveal-phone-image" loading="lazy" decoding="async" />
              <div className="studio-device-reveal-phone-ui">
                <div className="studio-device-reveal-phone-topbar">
                  <span>Ateno Studio</span>
                  <strong>Live room</strong>
                </div>
                <div className="studio-device-reveal-phone-sheet">
                  <span>Concept 03</span>
                  <h3>Calm bedroom redesign</h3>
                  <div className="studio-device-reveal-phone-tags">
                    <small>Warm minimal</small>
                    <small>Soft daylight</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
